import { ICategory } from '../interfaces';
import AxiosService from '../utils/axios-service';

export class CategoryService extends AxiosService {
  private static instance: CategoryService;

  constructor() {
    super('BFF_HELP_CENTER_URL');
  }

  static get getInstance(): CategoryService {
    if (!CategoryService.instance) {
      CategoryService.instance = new CategoryService();
    }
    return CategoryService.instance;
  }

  public async findAll(): Promise<any> {
    try {
      const url: string = 'category/findAll';
      const response: ICategory[] = await this.axios.post(url, { status: true });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default CategoryService.getInstance;
